import { useMelwaysLink } from '@seek/melways-react';
import { useLocation } from 'react-router-dom';

import { useConfig } from 'src/context/config';
import { useApplicationCorrelationId } from 'src/context/use-application-correlation-id';

const useGetSignInUrl = () => {
  const location = useLocation();
  const { config } = useConfig();
  const { applicationCorrelationId } = useApplicationCorrelationId();
  const searchParams = new URLSearchParams(location.search);

  // Add correlation ID
  searchParams.set('correlationid', applicationCorrelationId);

  const newSearchString = searchParams.toString();
  const returnUrl = `${location.pathname}?${newSearchString}`;
  const encodedReturnUrl = encodeURIComponent(returnUrl);
  const url = useMelwaysLink(config.SIGN_IN_PAGE);

  return `${url}?returnUrl=${encodedReturnUrl}`;
};

export { useGetSignInUrl };
